var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_17730",
    "data-name": "Group 17730",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9033",
    "data-name": "Rectangle 9033",
    fill: "none",
    stroke: "#d1d1d1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_whatsapp",
    "data-name": "vuesax/bold/whatsapp",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "whatsapp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG_164",
    "data-name": "BG 164",
    d: "M0,0H20V20H0Z",
    fill: "none",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.989,7.528A8,8,0,1,0,1.069,12L.357,14.648a.8.8,0,0,0,.984.976l2.608-.72A7.964,7.964,0,0,0,8,16,8.123,8.123,0,0,0,15.989,7.528Zm-4.08,3.448a1.909,1.909,0,0,1-.272.408,1.823,1.823,0,0,1-.656.472,1.958,1.958,0,0,1-.784.152,3.258,3.258,0,0,1-1.3-.3,7.327,7.327,0,0,1-1.376-.792A11.56,11.56,0,0,1,6.205,9.8a11.441,11.441,0,0,1-1.12-1.312A7.038,7.038,0,0,1,4.3,7.12a3.388,3.388,0,0,1-.288-1.312,2.09,2.09,0,0,1,.144-.776,1.786,1.786,0,0,1,.464-.672,1.156,1.156,0,0,1,.832-.376.782.782,0,0,1,.328.072.663.663,0,0,1,.272.224l.928,1.312a1.291,1.291,0,0,1,.16.28A.584.584,0,0,1,7.2,6.12a.574.574,0,0,1-.088.288,1.408,1.408,0,0,1-.224.288l-.3.32a.205.205,0,0,0-.064.16.4.4,0,0,0,.016.1.552.552,0,0,1,.032.08,3.207,3.207,0,0,0,.376.512c.184.208.376.424.584.632s.424.408.64.592a3.072,3.072,0,0,0,.52.368c.024.008.048.024.072.032a.262.262,0,0,0,.272-.056l.3-.3A1.285,1.285,0,0,1,9.621,8.9a.551.551,0,0,1,.288-.088.584.584,0,0,1,.248.056,1.456,1.456,0,0,1,.28.16l1.328.944a.675.675,0,0,1,.224.256.837.837,0,0,1,.064.312C12.005,10.68,11.973,10.832,11.909,10.976Z",
    transform: "translate(1.994 2)",
    fill: "rgb(37, 211, 102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H20V20H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.83562c8272429c6078b7c771e9a84517.svg";
export { ForwardRef as ReactComponent };